import { ReportDesignerPageOptions } from "../models/report-designer-page-options";
import { ReportDesignerWidgetConfig } from "../models/report-designer-widget-config";

/**
 * Helper for migrating existing template / report JSON to Angular Gridster 2 
 */
export class GridsterHelper {
  /**
   * Performs a widget conversion Gridster 1 -> Gridster 2 (Angular)
   * @param widget ReportDesignerWidget
   */
  public static updateWidgetForGridster2(widget: ReportDesignerWidgetConfig, pageOptions: ReportDesignerPageOptions): void {
    GridsterHelper.updatePosition(widget);

    GridsterHelper.updateMinSize(widget, pageOptions);
  }

  /**
   * Update the minimum size
   * @param widget
   * @param pageOptions
   */
  private static updateMinSize(widget: ReportDesignerWidgetConfig, pageOptions: ReportDesignerPageOptions) {
    if (widget.minItemCols === undefined) {
      widget.minItemCols = widget.minSizeX ? widget.minSizeX : 0;
    }

    if (widget.maxItemCols === undefined) {
      widget.maxItemCols = widget.maxSizeX ? widget.maxSizeX : pageOptions.maxCols;
    }

    if (widget.minItemRows === undefined) {
      widget.minItemRows = widget.minSizeY ? widget.minSizeY : 0;
    }

    if (widget.maxItemRows === undefined) {
      widget.maxItemRows = widget.maxSizeY ? widget.maxSizeY : pageOptions.maxRows;
    }

    if (widget.minItemRows > widget.maxItemRows) {
      //Bug 19282: Report Designer: Widget Income / Exit Balance of IRR
      //fix for bad widget configuration
      widget.maxItemRows = widget.minItemRows;
    }
  }

  /**
   * Update the position
   * @param widget
   */
  private static updatePosition(widget: ReportDesignerWidgetConfig) {
    if (widget.x === undefined) {
      widget.x = widget.col;
    }

    if (widget.y === undefined) {
      widget.y = widget.row;
    }

    if (widget.cols === undefined) {
      widget.cols = widget.sizeX;
    }

    if (widget.rows === undefined) {
      widget.rows = widget.sizeY;
    }
  }

  /**
    * Performs a page config conversion Gridster 1 -> Gridster 2 (Angular)
    * @param options ReportDesignerPageOptions
    */
  public static updatePageConfigForGridster2(options: ReportDesignerPageOptions): void {
    if (options.minCols === undefined) {
      options.minCols = options.cols || options.columns;
      options.maxCols = options.cols || options.columns;
    }

    if (options.fixedColWidth === undefined) {
      options.fixedColWidth = options.colWidth;
    }

    if (options.fixedRowHeight === undefined) {
      options.fixedRowHeight = options.rowHeight;
    }

    options.margin = 0;
    options.outerMarginTop = 0;
    options.outerMarginRight = 0;
    options.outerMarginBottom = 0;
    options.outerMarginLeft = 5;
    options.outerMargin = true;

    //always disallow swaping
    options.swap = false;
    options.swapWhileDragging = false;
    options.disablePushOnDrag = true;

    //don't allow dragging outside the grid edges
    options.enableBoundaryControl = true;
    options.disableScrollHorizontal = true;
    options.disableScrollVertical = true;
  }
}
